export const OFFSHORE_PCB_ID = 348;

export const PANEL_SHARE_ID = 690;

export const USA_QUICKTURN_ID = 726;

export const findVariantIdBySupplierCode = (supplier) => {
  switch (supplier) {
    case 'fabrication-us-panel-share':
      return PANEL_SHARE_ID;
    case 'fabrication-offshore-whx':
    case 'fabrication-offshore-whx-covid19':
      return OFFSHORE_PCB_ID;
    default:
      return USA_QUICKTURN_ID; // USA Quickturn
  }
};
